import { Component, inject } from '@angular/core';
import { RippleModule } from 'primeng/ripple';
import { TranslateModule } from '@ngx-translate/core';
import { PumbSettingsService } from '../pumb-settings.service';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-pumb-setting',
  standalone: true,
  imports: [RippleModule, TranslateModule, ToggleSwitchModule, FormsModule],
  template: `
    <div class="settings-item" pRipple (click)="toggle()" (keydown.enter)="toggle()" role="button" tabindex="0">
      <div>
        {{ 'screens.pumb.titles.integration' | translate }}
        <p>
          {{ 'screens.pumb.labels.integration_description' | translate }}
        </p>
      </div>
      <div>
        <p-toggleswitch [ngModel]="state.pumbEnabled()" [readonly]="true" />
        <!--
        <i class="pi" [class.pi-check-square]="state.pumbEnabled()" [class.pi-stop]="!state.pumbEnabled()"></i>
      -->
      </div>
    </div>
  `,
})
export class PumbSettingComponent {
  protected readonly state = inject(PumbSettingsService);

  toggle(): void {
    if (this.state.pumbEnabled()) {
      this.state.disablePumb();
    } else {
      this.state.enablePumb();
    }
  }
}
